<template>
  <div v-if="visited">
    <el-dialog v-el-drag-dialog :close-on-click-modal="false" :visible.sync="innerVisible" :title="title" width="1000px" :before-close="cancel" append-to-body class="app-main-inner adjust-window">
      <div class="app-main-inner-row">
        <el-form label-position="left" label-width="90px" :model="adjustCharge">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ChargeItem')">
                <cargo-advance-select
                  filterable
                  :method-params="getChargeItemFilter"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :default-value="Number(adjustCharge.chargeItemId) || ''"
                  options-width="250px"
                  tag-value="itemId"
                  :tag-name="$store.getters.language==='zh'?'zhName':'enName'"
                  :disabled="!isEditing"
                  :static-options="chargeItemList"
                  @parentCallBack="onChangeCompany"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.AuditDate')">
                <el-date-picker
                  v-model="adjustCharge.auditDate"
                  type="date"
                  style="width: 100%;"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :default-value="defaultAuditDate"
                  @change="auditDateChangeHandler"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.AccountObject')">
                <cargo-advance-select
                  v-if="isAr && arSettlementUnitOptional"
                  key="accountIdAr"
                  filterable
                  :method-params="{active:true}"
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="Number(adjustCharge.accountId) || ''"
                  :disabled="!isEditing"
                  options-width="200px;"
                  auto-key="auto_0"
                  tag-name="chineseName"
                  :static-options="companyFactorySigns"
                  @parentCallBack="textAccountCode_changeHandler"
                />
                <cargo-advance-select
                  v-else-if="isAr"
                  key="accountIdAr"
                  filterable
                  :method-params="{active:true}"
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="Number(adjustCharge.accountId) || ''"
                  :disabled="!isEditing"
                  options-width="200px;"
                  auto-key="auto_0"
                  :data-filter-function="dataFilterFunction"
                  @parentCallBack="textAccountCode_changeHandler"
                />
                <cargo-advance-select
                  v-else
                  key="accountIdAp"
                  filterable
                  :method-params="{active:true}"
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="Number(adjustCharge.accountId) || ''"
                  :disabled="!isEditing"
                  options-width="200px;"
                  auto-key="auto_0"
                  :data-filter-function="dataFilterFunction"
                  @parentCallBack="textAccountCode_changeHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-show="!isAdvance" :label="$t('SeaExport.ContactPerson')">
                <cargo-advance-select
                  :select-type="selectTypeNames.static_data_Contact"
                  options-width="160px;"
                  filterable
                  :cache="false"
                  :disabled="!isEditing"
                  :default-value="adjustCharge.contactPerson || ''"
                  :static-options="contactArray"
                  @parentCallBack="item=>adjustCharge.contactPerson=item.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-show="needMakeInvoice" :label="$t('SeaExport.IsNeedInvoice')">
                <cargo-advance-select
                  filterable
                  :clearable="false"
                  :fields="['value']"
                  :callback-params="{key:'needInvoice'}"
                  callback-method-type="value"
                  :default-value="adjustCharge.needInvoice"
                  :cache="false"
                  tag-value="code"
                  tag-name="value"
                  options-width="130px"
                  :disabled="!isEditing"
                  :static-options="[{code:false,value:$t('SeaExport.No')},{code:true,value:$t('SeaExport.Yes')}]"
                  :filter-tag-names="['value']"
                  @parentCallBack="item=>adjustCharge.needInvoice=item.value"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$t('FinanceManage.charge_invoiceHeader')">
                <cargo-advance-select
                  :filterable="true"
                  :filter-tag-names="['invoiceTitle']"
                  filter-type="global"
                  :allow-create="!arSettlementUnitOptional || !isAr"
                  :default-value="adjustCharge.invoiceTitle"
                  :disabled="!isEditing"
                  options-width="200px;"
                  tag-value="invoiceTitle"
                  tag-name="invoiceTitle"
                  :static-options="invoiceTitleList"
                  @parentCallBack="textInvoiceTitleChangeHandle"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('FinanceManage.charge_relatedContainerNo')">
                <el-select
                  ref="select"
                  v-model="adjustCharge.relationContainerNo"
                  :disabled="!isEditing"
                  @change="containerNoChangeHandle"
                >
                  <el-option
                    v-for="(item,index) in relatedContainerOption"
                    :key="index"
                    :label="item['containerNo']"
                    :value="item['containerNo']"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('FinanceManage.charge_relatedBLNo')">
                <el-select
                  ref="select"
                  v-model="adjustCharge.relatedMbl"
                  :disabled="!isEditing"
                >
                  <el-option-group
                    v-for="group in blOption"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="(item,index) in group.options"
                      :key="index"
                      :label="item['chargeRelatedBLNo']"
                      :value="item['chargeRelatedBLNo']"
                    />
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Unit')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_ChargeUnit"
                  filterable
                  :clearable="false"
                  options-width="100px"
                  :disabled="!isEditing"
                  :default-value="adjustCharge.measure || ''"
                  @parentCallBack="combMeasureChangeHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Quantity2')">
                <el-input-number v-model="adjustCharge.quantity" :max="99999999999999" :min="-99999999999999" :precision="3" style="width: 100%" :controls="false" :disabled="!isEditing" @change="txtQuantityChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.UnitRate')">
                <el-input-number v-model="adjustCharge.unitRate" :max="99999999999999" :min="-99999999999999" :precision="3" style="width: 100%" :controls="false" :disabled="!isEditing" @change="txtUnitRateChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Oversea')">
                <cargo-advance-select
                  filterable
                  :clearable="false"
                  :fields="['value']"
                  :callback-params="{key:'oversea'}"
                  callback-method-type="value"
                  :default-value="adjustCharge.oversea"
                  :cache="false"
                  tag-value="code"
                  tag-name="value"
                  :disabled="!isEditing || !canChangeOverseaOfCharge"
                  :static-options="[{code:false,value:$t('SeaExport.internal')},{code:true,value:$t('SeaExport.overseas')}]"
                  :filter-tag-names="['value']"
                  options-width="100px;"
                  @parentCallBack="item=>adjustCharge.oversea=item.value"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <div>
              <el-col :span="6">
                <el-form-item :label="$t('SeaExport.Currency')">
                  <cargo-advance-select
                    filterable
                    :clearable="false"
                    :select-type="selectTypeNames.basic_data_Currency"
                    :default-value="adjustCharge.currency || ''"
                    options-width="100px"
                    :disabled="!isEditing"
                    @parentCallBack="textCurrencyChangeHandler"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('SeaExport.ExchangeRate')">
                  <num-input
                    v-model="adjustCharge.exchangeRate"
                    :min="0"
                    :max="99999999999999"
                    :precision="8"
                    :truncated-precision="exchangeRatePrecision"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('CargoMsg.Cargo_DateType')">
                  <cargo-advance-select
                    :disabled="!isEditing"
                    :cache="false"
                    :clearable="false"
                    tag-name="name"
                    tag-value="code"
                    :static-options="dateTypeArray"
                    :default-value="dateType"
                    @parentCallBack="onDateTypeChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item v-if="inputIncludingTaxUnitPrice" :label="$t('FinanceManage.charge_unitPriceIncludeTax')">
                  <cargo-advance-select
                    filterable
                    :clearable="false"
                    :fields="['value']"
                    :callback-params="{key:'unitPriceIncludeTax'}"
                    callback-method-type="value"
                    :default-value="adjustCharge.unitPriceIncludeTax"
                    :cache="false"
                    tag-value="code"
                    tag-name="value"
                    options-width="130px"
                    :disabled="!isEditing"
                    :static-options="[{code:true,value:$t('SeaExport.Yes')},{code:false,value:$t('SeaExport.No')}]"
                    :filter-tag-names="['value']"
                    @parentCallBack="unitPriceIncludeTaxChange"
                  />
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.IncludingTaxAmount')">
                <el-input-number v-model="adjustCharge.amount" :max="99999999999999" :min="-99999999999999" :precision="2" style="width: 100%" :controls="false" :disabled="!isEditing" @change="textAmountChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-show="!isAdvance" :label="$t('SeaExport.ExcludingTaxAmount')">
                <el-input-number :max="99999999999999" :min="-99999999999999" :value="!needInvoiceNo ? adjustCharge.excludingTaxAmount : adjustCharge.amount" :disabled="!isEditing" :precision="2" style="width: 100%" :controls="false" @input="val=>{adjustCharge.excludingTaxAmount=val}" @change="excludingTaxAmountChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-show="!isAdvance" :label="$t('SeaExport.BillAmount')">
                <el-input-number v-model="adjustCharge.taxAmount" :max="99999999999999" :min="-99999999999999" :precision="2" style="width: 100%" :controls="false" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-show="!isAdvance" :label="$t('SeaExport.TaxRate')">
                <el-input-number :max="99999999999999" :min="-99999999999999" :value="isNaN(adjustCharge.taxRate) ? '0' : adjustCharge.taxRate" :precision="2" style="width: 100%" :controls="false" :disabled="!isEditing" @input="val=>{adjustCharge.taxRate=val}" @change="txtRateChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item v-show="needInvoiceNo" :label="$t('SeaExport.InvoiceNo')">
                <el-input v-model="adjustCharge.invoiceNo" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-show="!needInvoiceNo && openSapConfig" :label="$t('Invoice.invoice_settleDepartmentPrefix')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Department"
                  :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
                  :default-value="Number(adjustCharge.settleDepartmentPrefix) || ''"
                  :disabled="!isEditing"
                  options-width="150px"
                  @parentCallBack="item=>adjustCharge.settleDepartmentPrefix=item.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('SeaExport.Remarks')">
                <el-input v-model="adjustCharge.remarks" type="textarea" :rows="5" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="saveEvent">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button size="mini" @click="cancel">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 验证规则弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      :lob="checkingSaveJobWindow.lob"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import moment from 'moment'
import * as NumberUtils from '@/utils/NumberUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { getContacts } from '@/api/partner/contact'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { deepCopy, multiply, chargeItemLanguage } from '@/utils/commonUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import { Charge } from '@/class/model/act/Charge'
import { Company } from '@/class/model/mdm/Company'
import { getJobByUuid, saveAdjustJob } from '@/api/booking/job'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as ChargeUtilsForConstant from '@/class/cargo/model/utils/ChargeUtils'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { CHARGE_SOURCE_RED_FLUSH } from '@/class/cargo/model/parameters/SystemConstants'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import StrUtils from '@/utils/StrUtils'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow'
import BigNumber from 'bignumber.js'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import ColumnUtils from '@/utils/ColumnUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { queryBalanceList } from '@/api/clearing/advancePayment'
import { isExcludedOffice } from '@/api/sysManage/baseConfig/ExclusionOffice'
import { checkAccountClosed } from '@/api/act/closingAccount'

export default {
  name: 'AdjustWindow',
  components: { CargoAdvanceSelect, NumInput, checkingSaveJobWindow },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    defaultProperties: { type: Object, required: true }, // 弹框打开时默认传递条件
    viewSource: { type: String, default: '' }, // 页面请求发起方
    location: { type: String, required: false }
  },
  data() {
    const ADJUSTMENT_DATE = { code: 'AdjustmentDate', name: this.$t('Message.ByAdjustmentDate') }
    const BUSINESS_DATE = { code: 'BusinessDate', name: this.$t('Message.ByBusinessDate') }
    // 日期类型
    let dateType = LocalStorageUtilsNew.getConfiguration(this.dateTypeConfigKey, 'string')
    if (!dateType) {
      dateType = ADJUSTMENT_DATE.code
    }
    return {
      visited: false,
      ADJUSTMENT_DATE,
      BUSINESS_DATE,
      auditDateBack: '',
      userId: 0,
      officeId: 0,
      departmentId: 0,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      rowData: [],
      title: '',
      privilege: {
        isControlled: this.$checkPermission(['button_Charge_controlled']), // 是否有应付受控费用权限
        isCostControlled: this.$checkPermission(['button_Charge_costControlled']) // 是否有应收受控费用权限
      },
      isEditing: true, // 默认不能编辑
      contactArray: [],
      dateTypeArray: [ADJUSTMENT_DATE, BUSINESS_DATE], // 日期类型数组
      isAdjust: false, // 是否调整
      editMode: null, // 调整模式【新增/修改/删除 add/edit/del】
      isAdvance: false, //
      isAr: false,
      job: null,
      charge: false,
      companyTitle: null,
      costCharge: null,
      canChangeOverseaOfCharge: false, // 是否允许修改费用中国内国外的选项
      inputIncludingTaxUnitPrice: 0, // 单价是否含税
      useCheckRule: false,
      arSettlementUnitOptional: false,
      isSpecialExpenseEntryFunction: false,
      companyFactorySigns: [],
      isVerifiedAmount: false, // 费用调整是否直接销账掉
      getFeeRateType: false, // 0（红冲费用取原费用的汇率，即维持现状）；可选项1（红冲费用取调整界面录入的汇率，即跟增加出来的费用汇率一致）
      adjustCharge: {}, // 调整的费用
      dateType,
      blOption: [],
      relatedContainerOption: [],
      mblCargoDocSet: new Set(),
      hblCargoDocSet: new Set(),
      needInvoiceNo: false,
      dataSources: '', // 调用来源
      needMakeInvoice: true, // 是否显示是否开票
      selCurrency: false,
      openHecConfig: false,
      openSapConfig: false, // 打开Sap配置
      isZy: false, // 是否中邮
      isZyAdvancePaymentOpen: false, // 是否开启中邮预付款功能
      defaultAuditDate: new Date(),
      customerTitlesMap: new Map(), // 委托单位和关联的发票抬头
      invoiceTitleList: [],
      checkingSaveJobWindow: {
        lob: 'SE',
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: []
      },
      chargeItemList: [],
      loading: null,
      currentViewCacheData: {
        customerSettlementAgentMap: new Map() // 结算对象关联的结算代理
      }
    }
  },
  computed: {
    dateTypeConfigKey() {
      return this.$route.name + '_AdjustWindow_DateType'
    },
    getChargeItemFilter() {
      const filter = { ...(this.isAdvance ? { advance: this.isAdvance } : {}) }
      if (this.isAr) {
        if (!this.privilege.isCostControlled) {
          filter.controlled = false
        }
      } else {
        if (!this.privilege.isControlled) {
          filter.controlled = false
        }
      }
      if (this.isSpecialExpenseEntryFunction) {
        filter.specialExpenseMarker = false
      }
      filter.active = true
      return filter
    },
    exchangeRatePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(this.adjustCharge.currency)
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.visited = true
          this.defaultAuditDate = moment(new Date()).format('yyyy-MM-DD')
          this.onShow()
          this.userId = this.$store.getters.userId
          this.officeId = this.$store.getters.currentOfficeId
          this.departmentId = this.$store.getters.currentDeptId
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
  },
  beforeMount() {},
  beforeDestroy() {
    LocalStorageUtilsNew.setConfiguration(this.dateTypeConfigKey, this.dateType)
  },
  methods: {
    // 初始化权限及配置参数
    async initializeHandler() {
      this.$logger.log('defaultProperties', this.defaultProperties)
      const defaultProperties = this.defaultProperties
      if (this.defaultProperties) {
        // 初始化本界面需要的属性
        this.editMode = Object.prototype.hasOwnProperty.call(defaultProperties, 'editMode') ? defaultProperties['editMode'] : this.editMode
        this.isAdjust = Object.prototype.hasOwnProperty.call(defaultProperties, 'isAdjust') ? defaultProperties['isAdjust'] : this.isAdjust // 是否调整
        this.isAdvance = Object.prototype.hasOwnProperty.call(defaultProperties, 'isAdvance') ? defaultProperties['isAdvance'] : this.isAdvance
        this.needMakeInvoice = Object.prototype.hasOwnProperty.call(defaultProperties, 'needMakeInvoice') ? defaultProperties['needMakeInvoice'] : this.needMakeInvoice
        this.isAr = Object.prototype.hasOwnProperty.call(defaultProperties, 'isAr') ? defaultProperties['isAr'] : this.isAr
        this.job = Object.prototype.hasOwnProperty.call(defaultProperties, 'job') ? defaultProperties['job'] : this.job
        this.charge = Object.prototype.hasOwnProperty.call(defaultProperties, 'charge') ? defaultProperties['charge'] : this.charge
        this.needInvoiceNo = Object.prototype.hasOwnProperty.call(defaultProperties, 'needInvoiceNo') ? defaultProperties['needInvoiceNo'] : this.needInvoiceNo
        this.dataSources = Object.prototype.hasOwnProperty.call(defaultProperties, 'dataSources') ? defaultProperties['dataSources'] : this.dataSources
        this.companyFactorySigns = Object.prototype.hasOwnProperty.call(defaultProperties, 'companyFactorySigns') ? defaultProperties['companyFactorySigns'] : this.companyFactorySigns
        // 删除调整 不能编辑，新增、修改可以
        this.isEditing = this.editMode && this.editMode !== 'del'
      }
      // 初始化job
      const job = new Job(this.job)
      if (job) {
        // 加载数据
        job.charges = ''
        await Promise.all([
          job.getSeaEQ(),
          job.getCharges(),
          job.getCargoDoc()
        ])
      }
      // 配置参数
      this.openSapConfig = parseInt(cache.config.get('openSapConfig')) === 1
      this.openHecConfig = parseInt(cache.config.get('openHecConfig')) === 1
      this.getFeeRateType = parseInt(cache.config.get('getFeeRateType')) === 1
      this.isVerifiedAmount = parseInt(cache.config.get('VerifiedJustCharge')) === 1
      this.canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge')) > 0
      this.inputIncludingTaxUnitPrice = parseInt(cache.config.get('InputIncludingTaxUnitPrice'))
      this.useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      this.arSettlementUnitOptional = Number(cache.config.get('ArSettlementUnitOptional')) === 1
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
      this.isZy = String(cache.config.get('ToExoSystem')) === 'zy'
      this.isZyAdvancePaymentOpen = String(cache.config.get('ToExoSystem')) === 'zy' && Number(cache.config.get('isZhongyouAdvancePaymentOpen')) === 1
    },
    async onShow() {
      await cache.load(cacheName.CONFIG)
      await this.initializeHandler()
      if (this.editMode) {
        //
        // 若非增加调整，则将数据库中的费用替换界面传过来的费用，避免界面传过来的费用对象不完整
        if (this.charge && this.editMode !== 'add' && this.job.charges && this.job.charges.length > 0) {
          for (const c of this.job.charges) {
            if (c.uuid === this.charge.uuid) {
              this.charge = c
              break
            }
          }
        }
        // 设置窗口标题
        if (this.editMode === 'add') {
          this.title = this.isAdjust ? this.$t('Message.AddAdjustment') : this.$t('Message.AddCharge')
          this.charge.receivable = this.isAr
          // if (this.viewSource === 'FinanceManage') {
          this.charge.taxRate = ChargeUtils.getTaxRateAtCreateCharge(this.charge) // 获取税率
          // } else {
          //   ChargeUtils.changeItemRate(this.charge) // 获取税率
          // }
        } else if (this.editMode === 'edit') {
          this.title = this.isAdjust ? this.$t('Message.EditAdjustment') : this.$t('Message.EditCharge')
        } else {
          this.title = this.$t('Message.DeleteAdjustment')
        }
      }
      // 浅拷贝费用对象
      this.adjustCharge = deepCopy(this.charge)
      const adjustCharge = this.adjustCharge
      // CARGO-39247 对账新版-对账，点击查询报错
      if (adjustCharge && !adjustCharge.measure) {
        adjustCharge.measure = 'NML'
      }
      if (this.editMode === 'add' || this.editMode === 'edit') {
        if (this.inputIncludingTaxUnitPrice === 1) {
          adjustCharge.unitPriceIncludeTax = false
        } else if (this.inputIncludingTaxUnitPrice === 2) {
          adjustCharge.unitPriceIncludeTax = true
        }
        if (adjustCharge.unitPriceIncludeTax !== this.charge.unitPriceIncludeTax) {
          ChargeColumnUtil.unitPriceIncludeTaxChange(adjustCharge)
        }
      }
      if (this.isAdjust && adjustCharge) {
        let localCurrency
        if (this.editMode === 'add') {
          localCurrency = RateUtil.localCurrencyByOffice()
        } else {
          localCurrency = RateUtil.localCurrencyByOfficeId(this.charge.branchId)
        }
        if (this.editMode === 'add') {
          const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, adjustCharge.currency, this.getFeeRateType ? new Date() : adjustCharge.accountingDate, 0)
          // 增加调整，默认币种为RMB 则汇率为默认为1
          adjustCharge.exchangeRate = (isNaN(exchangeRate) || exchangeRate === 0) ? 1 : exchangeRate
        }
        if (this.editMode === 'edit') {
          // CARGO-8241，修改调整费用，切换窗口，币种会变成RMB
          if (this.selCurrency) {
            adjustCharge.currency = this.selCurrency ? this.selCurrency : adjustCharge.currency
          }
          // 修改调整时，根据当前日期的月份取汇率，调整日期为当前天
          const exchangeDate = this.getExchangeDateByDateType(this.job, new Date())
          const exchangeRate1 = await RateUtil.getForeignExchangeRateSafely(localCurrency, adjustCharge.currency, exchangeDate, this.charge.branchId)
          adjustCharge.exchangeRate = isNaN(exchangeRate1) ? 1 : exchangeRate1
        }

        // 给界面显示框初始化值
        this.$logger.log('adjustCharge', adjustCharge)
        const isInit = this.editMode && (this.editMode === 'edit' || this.editMode === 'del')
        adjustCharge['accountId'] = isInit ? adjustCharge['accountId'] : ''
        adjustCharge['contactPerson'] = isInit ? adjustCharge['contactPerson'] : ''
        const currency = adjustCharge['currency'] !== this.selCurrency ? adjustCharge['currency'] : this.selCurrency
        adjustCharge['currency'] = isInit ? currency : localCurrency
        adjustCharge['quantity'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['quantity'], 3) : 1.000
        adjustCharge['unitRate'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['unitRate'], 2) : 0.00
        adjustCharge['invoiceNo'] = isInit ? adjustCharge['invoiceNo'] : ''
        adjustCharge['chargeItemId'] = isInit ? adjustCharge['chargeItemId'] : ''
        const excludingTaxAmount = !this.needInvoiceNo ? NumberUtils.roundHalfUp(adjustCharge['excludingTaxAmount'], 2) : NumberUtils.roundHalfUp(adjustCharge['amount'], 2)
        adjustCharge['excludingTaxAmount'] = isInit ? excludingTaxAmount : 0.00
        adjustCharge['amount'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['amount'], 2) : 0.00
        adjustCharge['taxAmount'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['taxAmount'], 2) : 0.00
        adjustCharge['auditDate'] = this.auditDateBack || moment(new Date()).format('yyyy-MM-DD')
        adjustCharge['remarks'] = isInit ? adjustCharge['remarks'] : ''
        adjustCharge['measure'] = isInit ? adjustCharge['measure'] : 'NML'
        adjustCharge['needInvoice'] = isInit ? adjustCharge['needInvoice'] : true
        adjustCharge['controlled'] = isInit ? adjustCharge['controlled'] : true
        adjustCharge['relatedMbl'] = isInit ? adjustCharge['relatedMbl'] : ''
        adjustCharge['relationContainerNo'] = isInit ? adjustCharge['relationContainerNo'] : ''
        if (!isInit) {
          await ChargeUtils.getChargeOverseaByConfig(adjustCharge)
        }
        if (adjustCharge['accountId']) {
          this.loadContacts(adjustCharge['accountId'])
          await this.queryTitleByAccountId(adjustCharge)
          this.invoiceTitleList = this.getInvoiceTitleList(this.adjustCharge.accountId)
          await ChargeColumnUtil.getSettlementByCompanyId(adjustCharge, this.currentViewCacheData)
        }
      }
      this.chargeItemList = chargeItemLanguage()
      if (this.isZy && this.charge.receivable) {
        // CARGO-44102 中邮：财务审核-增加/修改/删除调整按钮，进行费用录入时，需按“新一代费用组”过滤
        await isExcludedOffice({ officeId: this.$store.getters.currentOfficeId }).then(res => {
          // 不在豁免分公司内则进行费用映射过滤
          if (!res.data) {
            this.chargeItemList = this.getChargeItemFromMappingForZY(this.chargeItemList)
          }
        })
      }
      await this.initCargoDocSet()
    },
    async saveEvent() {
      this.loading = getLoading4Cxt()
      if (!await this.validateCharge()) {
        this.closeLoading()
        return
      }
      //
      const adjustCharge = this.adjustCharge
      this.$logger.log('saveEvent-adjustCharge', adjustCharge)
      let item = null // 删除调整/修改调整
      let updateItem = null // 修改调整
      let checkDate = null
      if (this.editMode === 'edit') {
        checkDate = adjustCharge.auditDate
        if (this.charge.accountingDate && adjustCharge.auditDate) {
          const dA = moment(this.charge.accountingDate).format('YYYYMMDDkkmmss')
          const dB = moment(adjustCharge.auditDate).format('YYYYMMDDkkmmss')
          checkDate = dA < dB ? this.charge.accountingDate : checkDate
        }
      } else if (this.editMode === 'add') {
        checkDate = adjustCharge.auditDate
      } else {
        checkDate = this.charge.accountingDate
      }
      if (!checkDate) {
        checkDate = new Date()
      }
      if (this.editMode === 'add') {
        item = new Charge().fillDefaultValue().getData()
        item.jobUuid = this.job.uuid
        item.businessDate = this.job.businessDate
        item.inputBy = this.userId
        item.inputDate = new Date()
        item.inputByDep = this.departmentId
        item.branchId = this.officeId
        const localCurrency = RateUtil.localCurrencyByOfficeId(item.branchId)
        item.localCurrency = localCurrency
        item.accountId = Number(adjustCharge.accountId)
        item.invoiceTitle = adjustCharge.invoiceTitle
        item.oversea = adjustCharge.oversea
        if (this.openSapConfig) {
          item.settleDepartmentPrefix = adjustCharge.settleDepartmentPrefix
        }
        item.receivable = this.isAr
        item.chargeItemId = adjustCharge.chargeItemId
        item.currency = adjustCharge.currency
        item.verifiedAmount = 0
        item.auditDate = adjustCharge.auditDate
        item.auditor = this.userId
        item.accountingDate = adjustCharge.auditDate
        if (this.isAdjust) {
          item.exchangeRate = isNaN(adjustCharge.exchangeRate) ? 0 : Number(adjustCharge.exchangeRate)
        } else {
          item.exchangeRate = adjustCharge.exchangeRate
        }
        item.inputBy = this.userId
        item.advance = this.charge.advance
        item.adjustment = this.isAdjust
        item.measure = adjustCharge.measure
        item.quantity = parseFloat(adjustCharge.quantity)
        item.unitRate = parseFloat(adjustCharge.unitRate)
        item.taxRate = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxRate))
        item.amount = ChargeUtils.getRoundingValue(Number(adjustCharge.amount))
        item.unitPriceIncludeTax = adjustCharge.unitPriceIncludeTax
        item.taxAmount = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxAmount))
        item.excludingTaxAmount = this.needInvoiceNo ? item.amount : ChargeUtils.getRoundingValue(Number(adjustCharge.excludingTaxAmount))
        item.offsetState = 0
        if (this.job.jobState === 11) {
          item.chargeState = 0
        } else {
          item.chargeState = this.job.jobState
        }
        item.confirmState = this.charge.confirmState
        if (this.needInvoiceNo) {
          item.invoiceNo = adjustCharge.invoiceNo
        }
        if (this.openHecConfig) {
          item.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
        }
        item.contactPerson = adjustCharge.contactPerson
        item.remarks = adjustCharge.remarks
        item.relatedMbl = adjustCharge.relatedMbl
        item.relationContainerNo = adjustCharge.relationContainerNo
        // CARGO-44700 通过增加调整按钮 新增的 代收垫付费用，没有按照需求 CARGO-30722 ，把是否开票列默认为否
        if (this.dataSources === 'advanceChargeInfo') {
          item.needInvoice = false
        } else {
          item.needInvoice = adjustCharge.needInvoice
        }
        item.controlled = adjustCharge.controlled
        // CARGO-7916 更新费用序号
        item.serialNumber = this.refreshSerialNumber(this.isAr, this.job.charges)
        // CARGO-1073 通过调整费用
        // try {
        //   await this.queryTitleByAccountId(item)
        // } catch (error) {
        //   this.$logger.log('获取开票抬头错误', error)
        //   this.loading.close()
        // }
        item.settlementAgentId = Number(adjustCharge.settlementAgentId)
      } else {
        if (this.isAdjust) {
          item = new Charge().fillDefaultValue().getData()
          item.businessDate = this.job.businessDate
          item.chargeItemId = this.charge.chargeItemId
          item.receivable = this.charge.receivable
          item.oversea = this.charge.oversea
          item.shared = this.charge.shared
          item.shareRefNo = this.charge.shareRefNo
          item.commission = this.charge.commission
          item.advance = this.charge.advance
          item.prepaid = this.charge.prepaid
          item.accountId = this.charge.accountId
          item.currency = this.charge.currency
          item.measure = this.charge.measure
          item.quantity = this.charge.quantity
          item.unitRate = -(Number(this.charge.unitRate) || 0)
          item.branchId = this.charge.branchId
          const localCurrency = RateUtil.localCurrencyByOfficeId(item.branchId)
          item.localCurrency = localCurrency
          item.containerNo = this.charge.containerNo
          item.chargeState = this.charge.chargeState
          item.confirmState = this.charge.confirmState
          if (this.openHecConfig) {
            item.sapStatus = this.charge.sapStatus
          }
          if (this.charge && this.openSapConfig) {
            item.settleDepartmentPrefix = this.charge.settleDepartmentPrefix
          }
          item.inputBy = this.userId
          item.inputDate = new Date()
          item.inputByDep = this.charge.inputByDep

          item.auditor = this.userId
          item.auditDate = adjustCharge.auditDate
          // item.exchangeRate = RateUtil.getForeignExchangeRateSafely('RMB', item.currency, charge.accountingDate);
          item.exchangeRate = this.getFeeRateType ? isNaN(Number(adjustCharge.exchangeRate)) ? 0 : Number(adjustCharge.exchangeRate) : this.charge.exchangeRate
          // CARGO-985，费用是否开票，修改调整须一致
          // item.isNeedInvoice = isNeedInvoiceHandler(cbxIsNeedInvoice.selectedItem.data);
          if (this.dataSources === 'advanceChargeInfo') {
            item.needInvoice = false
          } else {
            item.needInvoice = this.charge.needInvoice
          }
          item.controlled = this.charge.controlled
          item.amount = -this.charge.amount
          item.unitPriceIncludeTax = this.charge.unitPriceIncludeTax
          if (!this.needInvoiceNo) {
            if (this.editMode === 'edit') {
              item.taxRate = this.charge.taxRate
              item.taxAmount = -this.charge.taxAmount
            } else {
              item.taxRate = ChargeUtils.getRoundingValue(Number(adjustCharge.taxRate))
              item.taxAmount = -ChargeUtils.getRoundingValue(Number(adjustCharge.taxAmount))
            }
          }
          item.excludingTaxAmount = this.needInvoiceNo ? item.amount : -ChargeUtils.getRoundingValue(this.charge.excludingTaxAmount)
          if (this.isVerifiedAmount) {
            item.verifiedAmount = item.amount
            item.paidOff = true
            this.charge.verifiedAmount = this.charge.amount
            this.charge.paidOff = true
          }
          item.adjustment = true
          item.offsetState = 2
          if (this.needInvoiceNo) {
            item.invoiceNo = this.charge.invoiceNo
          }
          item.accountingDate = adjustCharge.auditDate
          item.contactPerson = this.charge.contactPerson
          item.remarks = adjustCharge.remarks
          item.relatedMbl = adjustCharge.relatedMbl
          item.relationContainerNo = adjustCharge.relationContainerNo
          item.jobUuid = this.charge.jobUuid
          item.chargeSource = CHARGE_SOURCE_RED_FLUSH.code
          item.relatedId = this.charge.chargeId
          this.charge.offsetState = 1
          // CARGO-7916 更新费用序号
          item.serialNumber = this.refreshSerialNumber(this.isAr, this.job.charges)
          item.settlementAgentId = this.charge.settlementAgentId
          // CARGO-1073 通过调整费用
          try {
            await this.queryTitleByAccountId(item)
          } catch (error) {
            this.$message.error(error)
            this.closeLoading()
            this.$logger.log('获取开票抬头错误', error)
            return
          }
          if (this.editMode === 'edit') {
            updateItem = new Charge().fillDefaultValue().getData()
            updateItem.businessDate = this.job.businessDate
            updateItem.inputBy = this.userId
            updateItem.inputDate = new Date()
            updateItem.inputByDep = this.departmentId
            updateItem.branchId = this.officeId
            const localCurrency = RateUtil.localCurrencyByOfficeId(updateItem.branchId)
            updateItem.localCurrency = localCurrency
            updateItem.accountId = adjustCharge.accountId
            updateItem.invoiceTitle = adjustCharge.invoiceTitle
            updateItem.oversea = adjustCharge.oversea
            if (this.charge && this.openSapConfig) {
              updateItem.settleDepartmentPrefix = adjustCharge.settleDepartmentPrefix
            }
            updateItem.receivable = this.isAr
            updateItem.chargeItemId = adjustCharge.chargeItemId
            updateItem.currency = adjustCharge.currency
            updateItem.measure = adjustCharge.measure
            updateItem.quantity = parseFloat(adjustCharge.quantity)
            updateItem.unitRate = parseFloat(adjustCharge.unitRate)
            updateItem.taxRate = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxRate))
            updateItem.amount = ChargeUtils.getRoundingValue(Number(adjustCharge.amount))
            updateItem.unitPriceIncludeTax = adjustCharge.unitPriceIncludeTax
            updateItem.taxAmount = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxAmount))
            updateItem.excludingTaxAmount = this.needInvoiceNo ? updateItem.amount : ChargeUtils.getRoundingValue(Number(adjustCharge.excludingTaxAmount))
            updateItem.verifiedAmount = 0
            updateItem.chargeSource = CHARGE_SOURCE_RED_FLUSH.code
            updateItem.relatedId = this.charge.chargeId
            updateItem.auditor = this.userId
            updateItem.auditDate = adjustCharge.auditDate
            updateItem.accountingDate = adjustCharge.auditDate
            updateItem.advance = this.charge.advance
            updateItem.adjustment = true
            updateItem.chargeState = this.charge.chargeState
            updateItem.confirmState = 0
            updateItem.offsetState = 0
            if (this.needInvoiceNo) {
              updateItem.invoiceNo = adjustCharge.invoiceNo
            }
            if (this.openHecConfig) {
              updateItem.sapStatus = this.charge.sapStatus
            }
            // item.exchangeRate = RateUtil.getForeignExchangeRateSafely('RMB', item.currency, item.accountingDate);
            updateItem.exchangeRate = isNaN(Number(adjustCharge.exchangeRate)) ? 0 : Number(adjustCharge.exchangeRate)
            updateItem.needInvoice = adjustCharge.needInvoice // 新费用
            updateItem.controlled = adjustCharge.controlled
            updateItem.inputBy = this.userId
            updateItem.contactPerson = adjustCharge.contactPerson
            updateItem.remarks = adjustCharge.remarks
            updateItem.relatedMbl = adjustCharge.relatedMbl
            updateItem.relationContainerNo = adjustCharge.relationContainerNo
            updateItem.jobUuid = this.job.uuid
            // CARGO-7916 更新费用序号
            updateItem.serialNumber = this.refreshSerialNumber(this.isAr, this.job.charges)
            // CARGO-1073 通过调整费用 异步
            if (this.costCharge && this.costCharge.invoiceTitle && Number(this.costCharge.accountId) === Number(updateItem.accountId)) {
              updateItem.invoiceTitle = this.costCharge.invoiceTitle
            } else {
              // try {
              //   await this.queryTitleByAccountId(updateItem)
              // } catch (error) {
              //   this.$logger.log('获取开票抬头错误', error)
              //   this.loading.close()
              // }
            }
            updateItem.settlementAgentId = adjustCharge.settlementAgentId
          }
        } else {
          this.charge.accountId = adjustCharge.accountId
          this.charge.oversea = adjustCharge.oversea
          if (this.charge && this.openSapConfig) {
            this.charge.settleDepartmentPrefix = adjustCharge.settleDepartmentPrefix
          }
          this.charge.receivable = this.isAr
          this.charge.chargeItemId = adjustCharge.chargeItemId
          this.charge.currency = adjustCharge.currency
          this.charge.measure = adjustCharge.measure
          this.charge.quantity = parseFloat(adjustCharge.quantity)
          this.charge.unitRate = parseFloat(adjustCharge.unitRate)
          this.charge.taxRate = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxRate))
          this.charge.amount = ChargeUtils.getRoundingValue(Number(adjustCharge.amount))
          this.charge.unitPriceIncludeTax = adjustCharge.unitPriceIncludeTax
          this.charge.taxAmount = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxAmount))
          this.charge.excludingTaxAmount = this.needInvoiceNo ? item.amount : ChargeUtils.getRoundingValue(Number(adjustCharge.excludingTaxAmount))
          this.charge.verifiedAmount = 0
          if (this.needInvoiceNo) {
            this.charge.invoiceNo = adjustCharge.invoiceNo
          }
          this.charge.auditor = this.userId
          this.charge.auditDate = adjustCharge.auditDate
          this.charge.accountingDate = adjustCharge.accountingDate
          this.charge.needInvoice = adjustCharge.needInvoice
          this.charge.controlled = adjustCharge.controlled
          this.charge.exchangeRate = adjustCharge.exchangeRate
          this.charge.contactPerson = adjustCharge.contactPerson
          this.charge.remarks = adjustCharge.remarks
          this.charge.relatedMbl = adjustCharge.relatedMbl
          this.charge.relationContainerNo = adjustCharge.relationContainerNo
          this.charge.invoiceTitle = adjustCharge.invoiceTitle
          this.charge.settlementAgentId = adjustCharge.settlementAgentId
        }
      }
      // 费用调整保存
      const result = []
      if (this.editMode === 'add') {
        result.push(item)
      } else {
        if (this.isAdjust) {
          if (item) result.push(item)
          if (updateItem) result.push(updateItem)
          result.push(this.charge)
        } else {
          result.push(this.charge)
        }
      }
      // 查询预付款余额
      if (this.isZyAdvancePaymentOpen && result.length > 0) {
        const accountCodeMap = new Map()
        const customerCodes = []
        for (const item of result) {
          item.customerCode = ''
          if (accountCodeMap.has(item.accountId)) {
            item.customerCode = accountCodeMap.get(item.accountId)
          } else {
            const cmp = await Company.getCompanyById(item.accountId)
            if (cmp && cmp.externalKeyCust && cmp.ifAdvancePayment) {
              item.customerCode = cmp.externalKeyCust
              customerCodes.push(item.customerCode)
            }
            accountCodeMap.set(item.accountId, item.customerCode)
          }
        }
        // 客户编码
        if (customerCodes.length > 0) {
          const conditions = []
          const option = new AdvancedSearchOption(null, 'advancePayment.CUSTOMER_CODE', customerCodes, OperatorConstants.OPERATOR_BATCH.code)
          conditions.push(option.formatObj2Json())
          let balances = []
          try {
            await queryBalanceList({ conditions, branchId: this.$store.getters.currentOfficeId, pageNum: 1, pageSize: 20 }).then(res => { balances = res.data.list })
          } catch (error) {
            this.$message.error(error)
            this.closeLoading()
            return
          }
          for (const balance of balances) {
            for (const item of result) {
              if (item.uuid) continue
              const submittingAmount = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(multiply(new BigNumber(item.amount), new BigNumber(item.exchangeRate)), item.localCurrency), 2)
              if (item.customerCode === balance.customerCode) {
                // 本次待提交合计
                balance.unSubmitTotal = NumberUtils.ToFixed2(balance.unSubmitTotal + submittingAmount, 2)
              }
            }
          }
          console.log('advancePaymentBalances', balances)
          let promptText = ''
          // 提交校验需要满足：最新余额-已提交未审核的费用-本次提交费用>=0
          for (const balance of balances) {
            if (NumberUtils.ToFixed2(balance.balance - balance.submittingAmount - balance.unSubmitTotal, 2) < 0) {
              promptText += this.$t('AdvancePayment.CheckBalanceDetail2', [balance.customerCode, balance.customerName, NumberUtils.formatNumber(balance.balance, 2), NumberUtils.formatNumber(balance.submittingAmount, 2), NumberUtils.formatNumber(balance.unSubmitTotal, 2)]) + '<br>'
            }
          }
          if (promptText) {
            await this.$confirm(promptText, this.$t('AdvancePayment.CheckBalanceTitle'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Cancel'),
              dangerouslyUseHTMLString: true,
              customClass: 'checkBalanceConfirmWidth2',
              showCancelButton: false,
              type: 'warning'
            }).then(async() => {
              //
            })
            this.closeLoading()
            return
          }
        }
      }
      // CARGO-30908 环海：财务审核锁定应收和应付后，不允许再增加、修改、删除调整费用
      if (this.job && this.isAdjust) { // 增加调整、修改调整、删除调整时校验是否被锁定
        try {
          const curJob = await getJobByUuid(this.job.uuid).then(res => res.data)
          if (curJob) {
            const receivableChargeLockedStatus = curJob.receivableChargeLockedStatus || 0
            const payableChargeLockedStatus = curJob.payableChargeLockedStatus || 0
            if ((this.isAr && receivableChargeLockedStatus === 1) || !this.isAr && payableChargeLockedStatus === 1) {
              this.$message.warning(this.$t('Message.DataHadUpdated'))
              if (this.loading) this.loading.close()
              return
            }
          }
        } catch (error) {
          this.$message.error(error)
          this.closeLoading()
          return
        }
      }
      if (this.editMode === 'add') {
        await this.doCheckRule(result)
        return
      }
      await this.doSaveAdjustJob(result)
    },
    async doCheckRule(addedCharges) {
      if (this.useCheckRule && this.job) {
        try {
          const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, CheckRuleConstants.NODE_NEW_FINANCE_ADJUSTMENT.code, this.$store.getters.currentOfficeId)
          if (hasCheckRule) {
            const job = this.job._data ? this.job._data : this.job
            const charges = [...addedCharges]
            for (const addedCharge of addedCharges) {
              const amount = new BigNumber(addedCharge.amount)
              const exchangeRate = new BigNumber(addedCharge.exchangeRate)
              addedCharge.localAmount = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(multiply(amount, exchangeRate), addedCharge.localCurrency), 2)
            }
            if (job.charges) {
              for (const charge of job.charges) {
                charges.push(charge)
              }
            }
            const result = await JobUtils.checkBySaveJobNode({ job, charges }, this.job.lob, CheckRuleConstants.NODE_NEW_FINANCE_ADJUSTMENT.code)
            if (result.needShowDialog) {
              this.closeLoading()
              const callBack = () => {
                this.loading = getLoading4Cxt()
                this.doSaveAdjustJob(addedCharges)
              }
              this.checkingSaveJobWindow.lob = this.job.lob
              this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_NEW_FINANCE_ADJUSTMENT.code
              this.checkingSaveJobWindow.rowData = result.rowData
              this.checkingSaveJobWindow.callBack = callBack
              this.checkingSaveJobWindow.visible = true
            } else {
              await this.doSaveAdjustJob(addedCharges)
            }
          } else {
            await this.doSaveAdjustJob(addedCharges)
          }
        } catch {
          this.closeLoading()
        }
      } else {
        await this.doSaveAdjustJob(addedCharges)
      }
    },
    async doSaveAdjustJob(result) {
      await saveAdjustJob(result, { editMode: this.editMode, location: this.location }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        if (res.data) {
          this.$emit('returnCall', res.data)
          this.close()
        }
      }).finally(() => {
        this.$nextTick(() => {
          this.closeLoading()
        })
      })
    },
    async queryTitleByAccountId(item) {
      const c = await Company.getCompanyById(item.accountId)
      item.invoiceTitle = this.$store.getters.language === 'zh' ? c.chineseName : c.englishName
      if (c) {
        this.companyTitle = c
        this.costCharge = item
        let hasDefaultTitle = false
        const titles = await this.getTitlesByCompanyId(item)
        if (titles && titles.length > 0) {
          for (const t of titles) {
            if (t.defaultTitle) {
              this.costCharge.invoiceTitle = t.title
              if (this.costCharge.invoiceTitle) {
                hasDefaultTitle = true
                ChargeUtils.updateOverseaByInvoiceTitle(this.costCharge, titles)
              }
            }
          }
        }
        if (!hasDefaultTitle) {
          await ChargeUtils.updateOverseaByAccountId(this.costCharge)
        }
      }
    },
    refreshSerialNumber(isAr, charges) {
      let number = 1
      if (!charges) return number
      for (const c of charges) {
        if (c.receivable === isAr) {
          number++
        }
      }
      return number
    },
    // 费用项目改变
    async onChangeCompany(result) {
      this.$logger.log('费用项目', result)
      if (result) {
        const chargeItem = result
        this.adjustCharge.chargeItemId = Number(chargeItem.itemId)
        this.adjustCharge.currency = 'RMB'
        if (this.isAr && chargeItem.defaultarcurrency) {
          this.adjustCharge.currency = chargeItem.defaultarcurrency
        } else if (!this.isAr && chargeItem.defaultapcurrency) {
          this.adjustCharge.currency = chargeItem.defaultapcurrency
        }
        await this.textCurrencyChangeHandler(null)
        let accountId = 0
        if (this.isAr) {
          // 如果默认应收固定结算对象有值且维护的是当前分公司或者总公司，则取默认应收固定结算对象，否则取默认应收对象
          if (result.defaultArAccountId !== 0) {
            const company = await Company.getCompanyById(result.defaultArAccountId)
            // 当默认应收固定结算对象是当前分公或总公司时取值  否则不取值
            if (company.branchId === this.$store.getters.currentOfficeId || company.branchId === 1) {
              accountId = result.defaultArAccountId
            }
          } else if (chargeItem.defaultArCode) {
            if (chargeItem.defaultArCode === ChargeItemTarget.WTDW.code) {
              accountId = this.job.customerId
            } else if (chargeItem.defaultArCode === ChargeItemTarget.DCDW.code) {
              accountId = this.job.bookingAgent
            } else if (chargeItem.defaultArCode === ChargeItemTarget.MTGS.code) { // 码头公司
              if (this.job.lob === 'SE' || this.job.lob === 'SI') {
                accountId = this.job.terminalCompany
              }
            } else if (chargeItem.defaultArCode === ChargeItemTarget.CYR.code) {
              accountId = this.job.carrierId
            } else if (chargeItem.defaultArCode === ChargeItemTarget.HYDL.code) {
              accountId = this.job.destinationAgent
            } else if (chargeItem.defaultArCode === ChargeItemTarget.FYDL.code) {
              if (this.job.lob === 'RE' || this.job.lob === 'RI') {
                accountId = new RailwayExportJob(this.job).forwardingAgent
              }
            } else if (chargeItem.defaultArCode === ChargeItemTarget.FHR.code) {
              accountId = this.job.shipperId
            } else if (chargeItem.defaultArCode === ChargeItemTarget.SHR.code) {
              accountId = this.job.consigneeId
            } else if (chargeItem.defaultArCode === ChargeItemTarget.TZR.code) {
              accountId = this.job.notifyId
            }
          }
        } else if (!this.isAr) {
          // 如果默认应付固定结算对象是当前分公或总公司时取值  否则不取值
          if (result.defaultApAccountId !== 0) {
            const company = await Company.getCompanyById(result.defaultApAccountId)
            // 当默认应付固定结算对象是当前分公司，且符合应收应付条件则取值  否则不取值
            if (company.branchId === this.$store.getters.currentOfficeId || company.branchId === 1) {
              accountId = result.defaultApAccountId
            }
          } else if (chargeItem.defaultApCode) {
            if (chargeItem.defaultApCode === ChargeItemTarget.WTDW.code) {
              accountId = this.job.customerId
            } else if (chargeItem.defaultApCode === ChargeItemTarget.DCDW.code) {
              accountId = this.job.bookingAgent
            } else if (chargeItem.defaultArCode === ChargeItemTarget.MTGS.code) { // 码头公司
              if (this.job.lob === 'SE') {
                accountId = this.job.terminalCompany
              }
            } else if (chargeItem.defaultApCode === ChargeItemTarget.CYR.code) {
              accountId = this.job.carrierId
            } else if (chargeItem.defaultApCode === ChargeItemTarget.HYDL.code) {
              accountId = this.job.destinationAgent
            } else if (chargeItem.defaultApCode === ChargeItemTarget.FYDL.code) {
              if (this.job.lob === 'RE' || this.job.lob === 'RI') {
                accountId = new RailwayExportJob(this.job).forwardingAgent
              }
            } else if (chargeItem.defaultApCode === ChargeItemTarget.FHR.code) {
              accountId = this.job.shipperId
            } else if (chargeItem.defaultApCode === ChargeItemTarget.SHR.code) {
              accountId = this.job.consigneeId
            } else if (chargeItem.defaultApCode === ChargeItemTarget.TZR.code) {
              accountId = this.job.notifyId
            }
          }
        }

        // CARGO-31015 录入或修改费用名称，不论费用名称在收费项目维护的税率是否为0，都以费用名称的税率更新此条费用的税率，0税率的税率也为0（以费用名称税率为准）
        this.adjustCharge.taxRate = chargeItem.taxRate || 0
        if (this.isZy && this.charge.receivable && this.job.saleProductCode && this.job.fullOrInside) {
          const taxRate = ColumnUtils.getTaxRateFromMapping(this.adjustCharge.chargeItemId, this.job.saleProductCode, this.job.fullOrInside)
          this.adjustCharge.taxRate = taxRate
        }
        // CARGO-31003 在新增费用时，直接对特定的费用进行受控
        this.adjustCharge.controlled = chargeItem.controlled
        this.adjustCharge.needInvoice = chargeItem.needInvoice
        this.excludingTaxAmountChangeHandler()

        this.adjustCharge.accountId = accountId
        this.loadContacts(accountId)
        await this.refreshQuantity()
        const company = await Company.getCompanyById(accountId)
        if (company && Object.prototype.hasOwnProperty.call(company, 'cmpIdx')) {
          this.adjustCharge.oversea = (company.designationAgent || company.overseaAgent)
        }
        // 获取开票抬头
        if (accountId) {
          await this.queryTitleByAccountId(this.adjustCharge)
          this.invoiceTitleList = this.getInvoiceTitleList(this.adjustCharge.accountId)
        }
        await ChargeColumnUtil.getSettlementByCompanyId(this.adjustCharge, this.currentViewCacheData)
      }
    },
    // 修改费用项时，刷新数量
    async refreshQuantity() {
      const measure = this.adjustCharge.measure
      let quantity = this.adjustCharge.quantity
      if (measure === ChargeMeasure.WGT_CHARGE_MEASURE.code) {
        if (this.job.lob === 'AE') {
          quantity = this.job.weightActual
        } else {
          quantity = this.job.weightActual / 1000
          if (quantity < 1) quantity = 1
        }
      } else if (measure === ChargeMeasure.WGTT_CHARGE_MEASURE.code) {
        if (this.job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === this.job.typeHBL) {
          const hbl2 = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
          if (hbl2 && hbl2.weight) {
            quantity = hbl2.weight / 1000
          }
        } else if (this.job.lob === 'AE') {
          quantity = this.job.weightActual / 1000
        } else {
          quantity = this.job.weightActual / 1000
          if (quantity < 1) quantity = 1
        }
      } else if (measure === 'WGTX') {
        if (this.job.lob === 'AE') {
          if (this.adjustCharge.receivable) {
            quantity = this.job.cWeight
          } else {
            const mawb = await this.job.getCargoDocByDocType(CargoDocConsts.MAWB)
            quantity = !mawb ? 0 : mawb.cWeight
          }
        } else {
          quantity = this.job.chargeWeight
        }
      } else if (measure === 'VOL') {
        quantity = this.job.cubageActual
      } else if (measure === 'MIN') {
        quantity = 1
      } else if (measure === 'NML') {
        quantity = 1
      } else {
        quantity = this.getEQQuantity(measure)
      }
      this.adjustCharge.measure = measure
      this.adjustCharge.quantity = Number(quantity.toFixed(3))
    },
    // 修改费用项时，获取数量
    getEQQuantity(type) {
      let n = 0
      if (this.job.seaEQ) {
        for (const eq of this.job.seaEQ) {
          if (type === 'C20') {
            if (eq.eqSize === '20') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C40') {
            if (eq.eqSize === '40' && eq.eqType !== 'HQ') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C40H') {
            if (eq.eqSize === '40' && eq.eqType === 'HQ') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C45') {
            if (eq.eqSize === '45') {
              n = n + eq.eqQuantity
            }
          }
        }
      }
      return n === 0 ? 1 : n
    },
    // 单位
    async combMeasureChangeHandler(result) {
      this.$logger.log('单位', result)
      if (result) {
        this.adjustCharge.measure = result.code
      }
      await this.refreshQuantity()
      this.txtQuantityChangeHandler()
    },
    // 修改结算对象时，调整税率
    async textAccountCode_changeHandler(result) {
      this.$logger.log('结算对象', result)
      if (result) {
        const accountId = result.cmpIdx
        this.loadContacts(accountId) // 重新加载联系人
        this.adjustCharge.accountId = accountId

        // CARGO-31015 录入或修改费用名称，不论费用名称在收费项目维护的税率是否为0，都以费用名称的税率更新此条费用的税率，0税率的税率也为0（以费用名称税率为准）
        ChargeUtils.changeChargeRateByAccountId(this.adjustCharge)
        this.excludingTaxAmountChangeHandler()

        await ChargeUtils.getChargeOverseaByConfig(this.adjustCharge)
        await this.queryTitleByAccountId(this.adjustCharge)
        this.invoiceTitleList = this.getInvoiceTitleList(this.adjustCharge.accountId)
        await ChargeColumnUtil.getSettlementByCompanyId(this.adjustCharge, this.currentViewCacheData)
      }
    },
    getInvoiceTitleList(accountId) {
      if (this.customerTitlesMap.get(accountId)) {
        return this.customerTitlesMap.get(accountId).reduce((res, item) => {
          if (!res.find(re => re.invoiceTitle === item.invoiceTitle && re.taxAccount === item.taxAccount)) {
            res.push(item)
          }
          return res
        }, [])
      }
      return []
    },
    async getTitlesByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      if (this.customerTitlesMap.has(accountId)) {
        return this.customerTitlesMap.get(accountId)
      }
      // 获取数据库中维护的开票抬头
      const res = await queryTitleByCpmIdx(accountId)
      let dbTitles = res.data
      if (!dbTitles) dbTitles = []
      if (dbTitles.length > 0) {
        for (const title of dbTitles) {
          if (!title.title) continue
          title.invoiceTitle = title.title
        }
      }
      this.customerTitlesMap.set(accountId, dbTitles)
      return this.customerTitlesMap.get(accountId)
    },
    containerNoChangeHandle(val) {
      if (val) {
        let obj = {}
        obj = this.relatedContainerOption.find(item => {
          return item.containerNo === val
        })
        this.$set(this.adjustCharge, this.adjustCharge.relationContainerNo, val.value)
        this.this.adjustCharge.relationContainerNo = obj.label
      } else {
        this.adjustCharge.relationContainerNo = ''
        this.$set(this.adjustCharge, this.adjustCharge.relationContainerNo, '')
      }
    },
    textInvoiceTitleChangeHandle(result) {
      if (result) {
        this.adjustCharge.invoiceTitle = result.value
        if (this.adjustCharge.invoiceTitle) {
          ChargeUtils.updateOverseaByInvoiceTitle(this.adjustCharge, this.getInvoiceTitleList(this.adjustCharge.accountId))
        }
      }
    },
    // 数量
    txtQuantityChangeHandler() {
      const quantity = parseFloat(this.adjustCharge.quantity)
      if (!isNaN(quantity)) {
        this.adjustCharge.quantity = quantity
        if (this.adjustCharge.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(this.adjustCharge, multiply(quantity, this.adjustCharge.unitRate), this.adjustCharge.taxRate)
        } else {
          ChargeUtils.calculateTax(this.adjustCharge, multiply(quantity, this.adjustCharge.unitRate), this.adjustCharge.taxRate)
        }
      }
      this.adjustCharge.amount = this.adjustCharge.amount.toFixed(2)
    },
    // 单价
    txtUnitRateChangeHandler(result) {
      this.$logger.log('单价', result)
      const unitRate = parseFloat(ChargeUtils.ToFixed(parseFloat(result), 3))
      if (!isNaN(unitRate)) {
        this.adjustCharge.unitRate = unitRate
        this.$logger.log('this.adjustCharge.unitRate * this.adjustCharge.quantity', this.adjustCharge.unitRate * this.adjustCharge.quantity)
        this.$logger.log('this.adjustCharge.taxRate', this.adjustCharge.taxRate)
        const amount = ChargeUtils.ToFixed(this.adjustCharge.unitRate * this.adjustCharge.quantity, 3)
        if (this.adjustCharge.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(this.adjustCharge, amount, this.adjustCharge.taxRate)
        } else {
          ChargeUtils.calculateTax(this.adjustCharge, amount, this.adjustCharge.taxRate)
        }
      }
      if (this.adjustCharge) {
        this.adjustCharge.amount = this.adjustCharge.amount.toFixed(2)
      }
    },
    async onDateTypeChange(data) {
      this.dateType = data.value
      const exchangeDate = this.getExchangeDateByDateType(this.job, this.adjustCharge.auditDate)
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.adjustCharge.branchId)
      const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.adjustCharge.currency, exchangeDate, this.adjustCharge.branchId)
      this.adjustCharge.exchangeRate = isNaN(exchangeRate) ? '1' : exchangeRate.toString()
    },
    // 通过日期类型获取汇率对应日期
    getExchangeDateByDateType(job, adjustmentDate) {
      if (this.dateType === this.ADJUSTMENT_DATE.code) {
        return adjustmentDate
      } else if (this.dateType === this.BUSINESS_DATE.code) {
        return ['SE', 'AE', 'RE'].includes(job.lob) ? job.etd : job.eta
      } else {
        throw new Error('getExchangeDateByDateType: Not processed!')
      }
    },
    unitPriceIncludeTaxChange(data) {
      this.adjustCharge.unitPriceIncludeTax = data.value
      ChargeColumnUtil.unitPriceIncludeTaxChange(this.adjustCharge)
    },
    // 修改含税价
    textAmountChangeHandler(result) {
      this.$logger.log('含税价', result)
      const amount = parseFloat(ChargeUtils.ToFixed(parseFloat(result), 2))
      if (!isNaN(amount)) {
        this.adjustCharge.amount = amount
        ChargeUtils.calculateTaxAmount(this.adjustCharge, amount, this.adjustCharge.taxRate)
      }
      if (this.adjustCharge) {
        this.adjustCharge.unitRate = this.adjustCharge.unitRate.toFixed(2)
      }
    },
    // 修改不含税金额
    excludingTaxAmountChangeHandler() {
      if (this.charge.advance) return
      if (!isNaN(this.adjustCharge.excludingTaxAmount)) {
        ChargeUtils.calculateTax(this.adjustCharge, this.adjustCharge.excludingTaxAmount, this.adjustCharge.taxRate, true)
      }
    },
    // 税率
    txtRateChangeHandler() {
      if (this.charge.advance) return
      if (isNaN(this.adjustCharge.taxRate)) {
        this.adjustCharge.taxRate = 0.0
      }
      if (this.adjustCharge.unitPriceIncludeTax) {
        ChargeUtils.calculateTaxAmount(this.adjustCharge, Number(this.adjustCharge.amount), this.adjustCharge.taxRate)
      } else {
        ChargeUtils.calculateTax(this.adjustCharge, Number(this.adjustCharge.excludingTaxAmount), this.adjustCharge.taxRate)
      }
    },
    async textCurrencyChangeHandler(result) {
      this.$logger.log('币种', result)
      if (result) {
        this.adjustCharge.currency = result.code
      }
      this.selCurrency = this.adjustCharge.currency
      const exchangeDate = this.getExchangeDateByDateType(this.job, this.adjustCharge.auditDate)
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.adjustCharge.branchId)
      const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.adjustCharge.currency, exchangeDate, this.adjustCharge.branchId)
      this.adjustCharge.exchangeRate = isNaN(exchangeRate) ? '1' : exchangeRate.toString()
    },
    async auditDateChangeHandler() {
      // 调整日期的记忆变量
      this.auditDateBack = this.adjustCharge.auditDate
      if (this.dateType === this.ADJUSTMENT_DATE.code) {
        const localCurrency = RateUtil.localCurrencyByOfficeId(this.adjustCharge.branchId)
        const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.adjustCharge.currency, this.adjustCharge.auditDate, this.adjustCharge.branchId)
        this.adjustCharge.exchangeRate = isNaN(exchangeRate) ? '1' : exchangeRate.toString()
      }
    },
    // 加载结算对象所维护的联系人
    loadContacts(chargeAccountId) {
      getContacts({ cmpIdx: chargeAccountId }).then(res => {
        if (res.data) {
          this.contactArray = res.data
        }
      }).catch(error => {
        console.log('getContacts error', error)
      })
    },
    // 保存费用校验
    async validateCharge() {
      if (this.viewSource === 'FinanceManage') {
        if (!this.$checkPermission(['button_Charge_addAdjustment']) && this.$checkPermission(['button_Charge_addAdjustmentPositiveNum'])) {
          if (this.editMode === 'add' && this.adjustCharge['amount'] < 0) {
            this.$message.warning(this.$t('SystemMaintenance.OnlyPositiveFeePermission'))
            return false
          }
        }
        if (this.adjustCharge && this.adjustCharge.auditDate) {
          const res = await checkAccountClosed({ branchId: this.$store.getters.currentOfficeId, closeAccountDate: this.adjustCharge.auditDate })
          if (res.data) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CloseAccountTips1'))
            return
          }
        }
      }
      // Prevent from processing twice
      const job = new Job(this.job)
      if (job && job.charges && job.charges.length > 0) {
        for (const c of this.job.charges) {
          if (!c.uuid) return false
        }
      }
      const adjustCharge = this.adjustCharge
      if (!adjustCharge['currency']) {
        this.$message.warning(this.$t('Message.CurrencyOfAdjustmentCannotBeNull'))
        return false
      }
      if (!adjustCharge['auditDate']) {
        this.$message.warning(this.$t('Message.DateOfAdjustmentCannotBeNull'))
        return false
      }
      if (isNaN(adjustCharge['accountId']) || Number(adjustCharge['accountId']) === 0) {
        this.$message.warning(this.$t('Message.SettlementPartyCannotBeNull'))
        return false
      }
      if (isNaN(adjustCharge['chargeItemId']) || Number(adjustCharge['chargeItemId']) === 0) {
        this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
        return false
      }
      if (isNaN(adjustCharge['quantity']) || Number(adjustCharge['quantity']) === 0) {
        this.$message.warning(this.$t('Message.AmountCannotBeZero'))
        return false
      }
      if (isNaN(adjustCharge['exchangeRate']) || adjustCharge['exchangeRate'] === 0) {
        this.$message.warning(this.$t('Message.ExchangeCannotBeZero2'))
        return false
      }
      if (adjustCharge['remarks'] && adjustCharge['remarks'].length > 256) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RemarkTheLengthCannotExceedP256'))
        return false
      }
      if (this.needInvoiceNo) {
        if (!adjustCharge['invoiceNo']) {
          this.$message.warning(this.$t('Message.InvoiceNoCannotBeNull'))
          return false
        }
        if (adjustCharge['invoiceNo'].length > 32) {
          this.$message.warning(this.$t('Message.InvoiceNoIsTooLong'))
          return false
        }
      }
      if (this.editMode !== 'del' && adjustCharge['chargeItemId']) {
        const message = ChargeUtils.checkChargeRateRange(adjustCharge)
        if (message) {
          this.$message.warning(this.$t('CargoMsg.Cargo_TaxRateRangeLimit', [message]))
          return false
        }
      }
      this.closeLoading()
      if (!await ChargeUtils.checkUnitRate([adjustCharge], this)) {
        return false
      } else {
        this.loading = getLoading4Cxt()
      }
      return true
    },
    // 关闭时清空值
    clearInput() {
      this.selCurrency = ''
      this.editMode = null
      this.isAdjust = false // 是否调整
      this.isAdvance = false
      this.needMakeInvoice = true
      this.isAr = false
      this.job = null
      this.charge = null
      this.needInvoiceNo = false
      const adjustCharge = this.adjustCharge
      adjustCharge['accountId'] = ''
      adjustCharge['contactPerson'] = ''
      adjustCharge['currency'] = ''
      adjustCharge['quantity'] = 0.000
      adjustCharge['unitRate'] = 0.00
      adjustCharge['invoiceNo'] = ''
      adjustCharge['chargeItemId'] = ''
      adjustCharge['excludingTaxAmount'] = 0.00
      adjustCharge['amount'] = 0.00
      adjustCharge['taxRate'] = 0.00
      adjustCharge['taxAmount'] = 0.00
      // adjustCharge['auditDate'] = new Date()
      adjustCharge['remarks'] = ''
      this.adjustCharge = {}
    },
    cancel() {
      this.$confirm(this.$t('Message.CancelMotify'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.close()
      }).catch(() => {
      })
    },
    close() {
      this.clearInput()
      this.innerVisible = false
    },
    async initCargoDocSet() {
      const jobClass = new SeaExportJob(this.job)
      await jobClass.getCargoDoc()
      const mblCargoDocSet = []
      const hblCargoDocSet = []
      const j = this.job
      for (const seDoc of this.job.cargoDoc || []) {
        if (j.lob === 'SE' || j.lob === 'SI') {
          if (seDoc.docType === CargoDocConsts.MBL && j.signMBL) {
            if (!StrUtils.isEmpty(this.job.mbl)) {
              seDoc.chargeRelatedBLNo = this.job.mbl
              mblCargoDocSet.push(seDoc)
            }
          } else if (seDoc.docType === CargoDocConsts.MBL2 && j.signMBL && j.typeMBL !== 1 && !seDoc.deleted) {
            if (!StrUtils.isEmpty(seDoc.mblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.mblNbr2
              mblCargoDocSet.push(seDoc)
            }
          } else if ((seDoc.docType === CargoDocConsts.HBL || (seDoc.docType === CargoDocConsts.HBL2 && j.typeHBL !== 1)) && !seDoc.deleted && j.signHBL && !j.masterFlag) {
            if (!StrUtils.isEmpty(seDoc.hblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.hblNbr2
              hblCargoDocSet.push(seDoc)
            }
          }
        }
      }
      const optionsMBLValue = {}
      const optionsHBLValue = {}
      if (mblCargoDocSet.length > 0) {
        optionsMBLValue.label = 'MBL No.'
        optionsMBLValue.options = mblCargoDocSet
        optionsMBLValue.filterable = true
      }
      if (hblCargoDocSet.length > 0) {
        optionsHBLValue.label = 'HBL No.'
        optionsHBLValue.options = hblCargoDocSet
        optionsHBLValue.filterable = true
      }
      this.blOption = [optionsMBLValue, optionsHBLValue]
      const containerNoSet = []
      if (this.job.containers) {
        for (const c of this.job.containers) {
          if (c.containerNo && containerNoSet.indexOf(c) === -1) {
            containerNoSet.push(c)
          }
        }
      }
      this.relatedContainerOption = containerNoSet
    },
    dataFilterFunction(item) {
      if (this.isAr) { // 应收
        if (item.ifCustomer) { // 判断是 客户
          return true
        }
      } else { // 应付
        if (item.ifSupplier) {
          return true
        }
      }
      return false
    },
    // 中邮费用项目根据费用映射过滤
    getChargeItemFromMappingForZY(chargeItems) {
      const saleProductCode = this.job.saleProductCode
      const fullOrInside = this.job.fullOrInside
      if (!saleProductCode && !fullOrInside) {
        return chargeItems
      }
      const chargeMappingResult = getFilterCacheList(TYPE_NAMES.basic_data_ChargeMapping, (mapping) => {
        return mapping.saleProductCode === saleProductCode && mapping.fullOrInside === fullOrInside
      })
      const filteredItems = chargeItems.filter(item => {
        for (const mapping of chargeMappingResult) {
          if (item.itemId === mapping.chargeItemId) {
            return true
          }
        }
      })
      return filteredItems
    },
    closeLoading() {
      if (this.loading) {
        this.loading.close()
      }
    }
  }
}
</script>

<style lang="scss">
  .adjust-window {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>
